import type { FC } from 'react'
import { CircularProgress } from '@mui/material'
import { tss } from '@dhl/theme'

type Props = {
  isMiddle?: boolean
}

const useStyles = tss.makeStyles()((theme) => ({
  root: {
    zIndex: theme.zIndex.tooltip + 1,
  },
  center: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    marginLeft: '-20px',
    marginTop: '-20px',
  },
}))

/**
 * Loading
 * TODO: candidate for a normal loader with option to have it for full page or only horizontal position
 */
export const Loading: FC<Props> = ({ isMiddle = false }) => {
  const { classes } = useStyles()
  return <CircularProgress className={isMiddle ? classes.center : classes.root} />
}
